import {useState} from "react";
import {useEffect} from "react";
import {useLocation} from "react-router-dom";
// Custom hook for copy to clipboard functionality
export const useCopyClipboard = () => {
  const [copyStatus, setCopyStatus] = useState();
  const isObject = (value) => {
    return value !== null && typeof value === "object";
  };

  const handleCopyClipboard = async (data) => {
    try {
      const textToCopy = isObject(data) ? JSON.stringify(data) : String(data);
      await navigator.clipboard.writeText(textToCopy);
    } catch (err) {
      console.error("Unable to copy to clipboard.", err);
    }

    setCopyStatus(true);
    setTimeout(()=>{
      setCopyStatus(false);
    }, 1000);
  };
  return {copyStatus, handleCopyClipboard};
};
// to convert first letter uppercase of a string
export const firstLetterUpperCase = (word) =>{
  if (word && word.length>0) {
    return word[0].toUpperCase() + word.slice(1);
  }
  return word;
};

// Page scroll to top
export const ScrollToTop = () =>{
  const {pathname} = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export const findIdForKey=(data, keyToFind) =>{
  let foundId = null;
  data?.forEach(([_, obj]) => {
    for (const key in obj) {
      if (key===keyToFind) {
        foundId = obj.id;
        return;
      }
    }
  });
  return foundId;
};

export const extractTitleAndSchemaId = (item) => {
  let title= "";
  let uniqueSchemaId="";
  for (const key in item[1]) {
    if (typeof item[1][key]==="object") {
      title= key;
    } else uniqueSchemaId= item[1][key];
  }
  return {title, uniqueSchemaId};
};
